// extracted by mini-css-extract-plugin
module.exports = {"main":"marketTip_main__3IvhZ"};